import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-print-button',
    templateUrl: './print-button.component.html',
    styleUrls: ['./print-button.component.scss'],
    standalone: false
})
export class PrintButtonComponent implements OnInit {
//add note functionality story
  @Input() label: string;

  showButton: boolean = true;
  
  constructor() { }

  onPrintPage() {
    window.print();
  }

  ngOnInit() {
  }

}
